export const formatPayMethod = (id) => {
  const idNum = Number(id);
  if (!idNum) return;
  if (idNum === 1) return 'Cartão de Crédito';
  if (idNum === 2) return 'Pix';
  if (idNum === 3) return 'Boleto';
  if (idNum === 4) return 'Cartão de Débito';
  if (idNum === 5) return 'Cartão de Crédito Recorrente';
};
